{
    "coordinates": [
        30.611704826572094,
        -5.711298273821711
    ],
    "tooltip": "Fezouata",
    "title": "Fezouata Formation",
    "country": "Morroco",
    "period": "Ordovician",
    "alt": "TODO"
}